module.exports = __webpack_public_path__ + "img/chevron-down-dark.d19dbd82.svg";